/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenKey = '';
if (process.env.CUS_NODE_ENV === 'test') {
  TokenKey = 'test-token';
} else if (process.env.CUS_NODE_ENV === 'test2') {
  TokenKey = 'test-token';
} else if (process.env.CUS_NODE_ENV === 'development') {
  TokenKey = 'test-token';
} else if (process.env.CUS_NODE_ENV === 'pre') {
  TokenKey = 'pre-token';
} else if (process.env.CUS_NODE_ENV === 'production') {
  TokenKey = 'premission-token';
} else {
  TokenKey = '';
}
function getToken() {
  return _jsCookie2.default.get(TokenKey);
}

function setToken(token) {
  return _jsCookie2.default.set(TokenKey, token);
}

function removeToken() {
  return _jsCookie2.default.remove(TokenKey);
}

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "premissionAuth.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/utils/premissionAuth.jsx
// module id = 330
// module chunks = 0